import AccessDeniedPage from "@/shared/components/error-pages/access-denied-page";
import { GenericErrorPage } from "@/shared/components/error-pages/generic-error-page";
import ResourceNotFoundPage from "@/shared/components/error-pages/resource-not-found-page";
import ServiceUnavailablePage from "@/shared/components/error-pages/service-unavailable-page";
import { normalizeHttpError } from "@/shared/utils/errors/http-error.factory";
import { useRouteError } from "react-router-dom";

const ErrorPage = () => {
  const error = useRouteError();
  // Normalize the error to use HttpError methods
  const httpError = normalizeHttpError(error);

  if (httpError.isServiceUnavailable) {
    return <ServiceUnavailablePage />;
  }

  if (httpError.isAccessDenied) {
    return <AccessDeniedPage />;
  }

  if (httpError.isNotFound) {
    return <ResourceNotFoundPage />;
  }

  if (httpError.isNoDataError) {
    return <AccessDeniedPage />;
  }

  return <GenericErrorPage />;
};

export default ErrorPage;
